import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  effect,
  inject,
} from '@angular/core';
import { SmsAggregator } from '../api/models';
import { AppStateService } from '../services/app-state.service';

@Directive({
  selector: '[mobileOperatorImg]',
  standalone: true,
})
export class MobileOperatorImgDirective implements OnInit {
  appStateService = inject(AppStateService);
  @Input('mobileOperatorImg') smsAggregator: MobileOperatorData;
  constructor(private element: ElementRef, private renderer: Renderer2) {
    effect(() => {
      (this.element.nativeElement as HTMLElement).innerHTML = '';
      switch (this.smsAggregator.mobileOperator) {
        case SmsAggregator.MCI:
        case SmsAggregator.Irancell:
        case SmsAggregator.Rightel:
          this.createImageTag();
          break;
        default:
          this.createSpanTag();
          break;
      }
    });
  }

  ngOnInit(): void {}

  getSmsAggregatorImg(tagName: any): any {
    let imgSrc = '';

    switch (this.smsAggregator.mobileOperator) {
      case SmsAggregator.MCI:
        imgSrc = this.appStateService.currentThemeMode()
          ? '/assets/media/svg/operator/mci-dark.svg'
          : '/assets/media/svg/operator/mci.svg';
        break;
      case SmsAggregator.Irancell:
        imgSrc = '/assets/media/svg/operator/mtn.svg';
        break;
      case SmsAggregator.Rightel:
        imgSrc = this.appStateService.currentThemeMode()
          ? '/assets/media/svg/operator/rightel-dark.svg'
          : '/assets/media/svg/operator/rightel.svg';
        break;
      default:
        break;
    }

    this.renderer.setAttribute(tagName, 'src', imgSrc);
  }

  getSmsAggregatorImgStyle(): any {
    let classList = 'tw-mx-3 tw-p-1  ';

    switch (this.smsAggregator.mobileOperator) {
      case SmsAggregator.MCI:
        classList += 'tw-w-[50px] tw-h-[31px] mobile-operator ';
        break;
      case SmsAggregator.Irancell:
        classList += 'tw-w-[25px] tw-h-[25px]';
        break;
      case SmsAggregator.Rightel:
        classList += 'tw-w-[50px] tw-h-[26px] mobile-operator ';
        break;
      case SmsAggregator.NotValid:
        classList += 'fw-700 text-danger ';
        break;
      case SmsAggregator.Other:
        classList += 'fw-700 text-sky ';
        break;
      default:
        break;
    }
    return classList;
  }

  createImageTag() {
    const img = this.renderer.createElement('img');
    this.renderer.appendChild(this.element.nativeElement, img);
    this.getSmsAggregatorImg(img);
    img.className = this.getSmsAggregatorImgStyle();
  }

  createSpanTag() {
    const span = this.renderer.createElement('span');
    span.innerText = this.smsAggregator.mobileOperatorEnumValue;
    this.renderer.appendChild(this.element.nativeElement, span);
    span.className = this.getSmsAggregatorImgStyle();
  }
}

interface MobileOperatorData {
  mobileOperator: number;
  mobileOperatorEnumValue: string;
}
